module.exports = __webpack_public_path__ + "img/deposit-over.090311a2.svg";